
<template>
	<div class="comp">
		<div class="mask">
			<div class="maskCon">
				<img src="../../assets/img/cha.png" class="closeIcon" @click="close"/>
				<div class="loginBox">
					<div class="L">
						<img src="../../assets/img/login/loginBg.png" style="width:100%;height: 100%;" />
					</div>
					<div class="R">
						<div class="tit">
							<span style="font-size: 22px;color:#303042;font-weight: bold;">登录后</span> 解锁更多权限！
						</div>
						<div class="loginPanel">
							<div class="inputLine">
								<span class="text86">+86</span>
								<el-input v-model="userName" placeholder="请输入手机号"></el-input>
							</div>
							<div style="display: flex;margin-bottom:28px;">
								<div class="inputLine" style="width:190px;margin: 0;">
									<el-input type="password" v-model="userPwd" @keyup.enter.native="login" placeholder="短信验证码"></el-input>
								</div>
								<span class="textPhoneCode" @click="sendCode">{{codeNum===0?'获取验证码':codeNum+'秒'}}</span>
							</div>
							<div class="loginBtn" @click="login">立即登录</div>
							<div class="checkedLine">
								<img src="../../assets/img/login/loginChecked.png" v-if="checkedState" @click="checkedState=!checkedState" style="width: 15px; vertical-align: sub;cursor: pointer;"/>
								<img src="../../assets/img/login/loginNoChecked.png" v-else @click="checkedState=!checkedState" style="width: 15px; vertical-align: sub;cursor: pointer;"/>
								登录即同意<span style="cursor: pointer;color:#9F9FAC;">《用户协议》</span>和<span style="cursor: pointer;color:#9F9FAC;">《隐私政策》</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let Base64 = require('js-base64').Base64
	export default {
		data() {
			return {
				dialogState:true,
				
				userName:'',
				userPwd:'',
				systemId:'654321',
				
				codeNum:0,
				timer:null,
				
				checkedState:false,
				
			}
		},
		computed:{
			
		},
		mounted(){
			
		},
		methods:{
			close(){
				console.log(111)
				this.$emit("submit",{type:'close'})
			},
			sendCode(){
				if(!this.$public.isTel(this.userName)){
					this.$message({
						message: '手机号输入有误',
						type: 'error'
					});
					return ;
				}
				if(this.codeNum!==0){
					return ;
				}
				this.codeNum=59;
				this.timer = setInterval(()=>{
					this.codeNum--;
					if(this.codeNum===0){
						clearInterval(this.timer)
					}
				},1000)
				let params = {
					"phone": this.userName,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/Sms/login/code', params).then(res => {
					loading.close()
					if(res.code===0){
						this.$message({
							message: res.data,
							type: 'success'
						});
					}
				})
			},
			login(){
				if(this.$public.isNull(this.userName)){
					this.$message({
						message: '请输入用户名',
						type: 'error'
					});
					return ;
				}else if(this.$public.isNull(this.userPwd)){
					this.$message({
						message: '请输入密码',
						type: 'error'
					});
					return ;
				}
				if(this.checkedState===false){
					this.$message({
						message: '请先阅读并同意以下条款',
						type: 'error'
					});
					return ;
				}
				let params = {
					"phone": this.userName,
					// "code":Base64.encode(this.userPwd),
					"code":this.userPwd,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/Login/PhoneCode', params).then(res => {
					loading.close()
					if(res.code===0){
						// this.$store.commit('setInviteCode',this.$route.query.inviteCode||'')
						this.$store.commit('setIp',sessionStorage.getItem("ip"))
						this.$store.commit('setAccessToken',res.data.accessToken)
						this.getUserDetail(res.data.userId)
					}
				})
			},
			getUserDetail(userId){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/User/info', {
					"id": userId,
				}).then(res => {
					loading.close()
					if(res.code===0){
						this.$store.commit('setUserInfo',res.data)
						this.$emit("submit",{type:'success'})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		position: fixed;width:100%;height: 100%;top:0;left:0;
		.mask{
			background-color: rgba(0,0,0,.4);width:100%;height: 100%;
			.maskCon{
				width:810px;height: 450px;position: relative;top:50%;left:50%;transform:translate(-50%, -50%);
				.closeIcon{
					width: 40px; height: 40px; position: absolute; right: -50px;cursor: pointer;
				}
				.loginBox{
					width:100%;height: 100%;display: flex;overflow: hidden;border-radius: 0 16px 16px 0;
					.L{
						width:350px;height: 100%;
					}
					.R{
						width:460px;background-color: #fff;padding: 50px 60px;box-sizing: border-box;
						.tit{
							font-size: 16px;color:#6A6A7E;margin-bottom:40px;
						}
						.loginPanel{
							.inputLine{
								height: 48px;width:340px;box-sizing: border-box;padding:3px 0;margin:0 auto 27px;border: 1px solid #D4D4D4;border-radius: 2px;
								::v-deep .el-input{
									width:188px;vertical-align: bottom;
									.el-input__inner{
										background-color: transparent;border:0;font-size: 16px;color:#303042;
									}
								}
								.text86{
									font-size: 16px;color:#000000;padding:0px 10px;margin:10px 0;border-right: 1px solid #707070;display: inline-block;line-height: 20px;box-sizing: border-box;
								}
								
							}
							.textPhoneCode{
								font-size: 14px;color:#303042;padding:0px 20px;display: inline-block;line-height: 48px;box-sizing: border-box;text-align: center;width:140px;background-color: #F9D600;margin-left:10px;cursor: pointer;border-radius: 2px;
							}
							.checkedLine{
								font-size: 12px;color:#6A6A7E;
							}
							.loginBtn{
								width:100%;background-color: #F9D600;line-height: 48px;text-align: center;cursor: pointer;color:#fff;font-size: 16px;margin:27px auto;color:#303042;
							}
						}
					}
				}
			}
		}
	}
</style>
